import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import {
	getBanner,
	insertBanner,
	removeSubscription,
	requestBannersRefresh,
	subscribeToBannersUpdates,
} from '@braze/web-sdk';
import noop from 'lodash/noop';

import { useBrazeProvider } from 'Context/BrazeContext/BrazeContext';

import { BRAZE_BANNERS_ID } from './BrazeBanner.helpers';

import styles from './BrazeBanner.module.scss';

const BRAZE_BANNERS_IDS = Object.values(BRAZE_BANNERS_ID);

export const BrazeBanner = ({ bannerId, className }: { bannerId: string; className?: string }) => {
	const bannerRef = useRef<HTMLDivElement>(null);
	const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
	const [hasBanner, setHasBanner] = useState(false);
	const { isBrazeSDKInitialised } = useBrazeProvider();

	useEffect(() => {
		if (!isBrazeSDKInitialised) {
			return noop;
		}

		const subscriptionId = subscribeToBannersUpdates(() => {
			const banner = getBanner(bannerId);

			if (!banner || !bannerRef.current) {
				return noop;
			}

			insertBanner(banner, bannerRef.current);

			clearTimeout(timerRef.current!);
			timerRef.current = setTimeout(() => {
				setHasBanner(true);
			}, 500);

			return noop;
		});

		requestBannersRefresh(BRAZE_BANNERS_IDS);

		return () => {
			if (subscriptionId) {
				removeSubscription(subscriptionId);
			}
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
		};
	}, [bannerId, isBrazeSDKInitialised]);

	return (
		<div key={bannerId} className={cx(styles.container, className, { [styles.showBanner]: hasBanner })}>
			<div ref={bannerRef} className={styles.brazeContainer}></div>
		</div>
	);
};
